var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('h1',[_vm._v("Sorry, this page is not available ⚠️")]),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.redirectMe()}}},[_vm._v(" Go Home ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }